export default __webpack_public_path__ + "static/media/dudu_badge_4.9bde59ea.svg";